angular.module('unergie.main')
.directive('importLandscape', (AlertManager, ApiUser, ErrorCatcher, BoFeaturesService) =>
    ({
        restrict: 'E',
        scope: {
            contract: '=',
            canLandscape: '&',
            onDone: '&',
            isDraft: '=',
            defaultSource: '=',
        },
        templateUrl: '/directives/import-landscape/import-landscape.html',
        link($scope) {
            $scope.canImportLandscape = BoFeaturesService.getModuleFeatures('contracts').canImportLandscape
            $scope.popupImportTemplate = {
                id_contract: $scope.defaultSource,
            }
            $scope.popupImportFields = {
                expl: {
                    label: "Vous allez importer le paysage d'un<br>autre contrat<br><br>",
                    type: 'label',
                },
                id_contract: {
                    label: 'Contrat',
                    type: 'text',
                    required: true,
                },
            }

            $scope.importLandscape = function () {
                const idContract = $scope.popupImportTemplate.id_contract

                return ApiUser.searchLandscape({ idContract, draft: false, format: 'survey' }).$promise.then((pLandscape) => {
                    if (pLandscape && pLandscape.survey) {
                        return pLandscape
                    }
                    return ApiUser.searchLandscape({ idContract, draft: true, format: 'survey' }).$promise
                }).then((pLandscape) => {
                    if (!pLandscape || !pLandscape.survey) {
                        return AlertManager.error(`Pas de paysage à importer depuis ${idContract}`, 5000)
                    }

                    const landscape = pLandscape.toJSON()
                    const isDraft = _.isNil($scope.isDraft) ? true : $scope.isDraft
                    return ApiUser.postFullLandscape({ idContract: $scope.contract.id, draft: isDraft }, landscape).$promise.then((result) => {
                        AlertManager.success(`Paysage importé avec succès depuis ${idContract}`)
                        $scope.onDone({ $event: _.assign({}, result, landscape) })
                    })
                }).catch(ErrorCatcher)
            }
        },
    })
)
